import { getVideoEmbedUrl, VideoSource } from "@/components/rich-editor/extensions/video-url.ts";
import { twMerge } from "tailwind-merge";

interface VideoEmbedProps {
  source: VideoSource;
  title?: string;
  className?: string;
}

export function VideoEmbed({ source, title, className }: VideoEmbedProps) {
  const classes = twMerge("block w-full aspect-video rounded-xs bg-dark", className);

  if (source.kind === "file") {
    return <video src={source.src} controls preload="metadata" title={title} className={classes} />;
  }

  return (
    <iframe
      src={getVideoEmbedUrl(source)}
      title={title ?? source.kind}
      className={classes}
      loading="lazy"
      allow="autoplay; encrypted-media; fullscreen; picture-in-picture"
      allowFullScreen
    />
  );
}
